import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import Simula from './components/Simulator/Simula';
import Preguntas_Frecuentes from './pages/Preguntas_Frecuentes';
import Principal from './pages/Principal';
import ProductoDimanicoDigital from './components/Producto/ProductoDinamicoDigital';
import Red_Agencias from './pages/Red_Agencias';
import Solicitud from './components/Producto/ProductoDinamico/Solicitud';
import Seguros from './pages/Seguros';
import Convenios from './pages/Convenios';
import CreditoLibranza from './pages/CreditoLibranza';
import QuieroAsociarme from './pages/QuieroAsociarme';
import Asociados from './pages/Asociados';
import CDAT from './pages/CDAT';
import SeccionTransaccional from './pages/SeccionTransaccional';
import PSE from './pages/PSE';
import Revalorizacion from './pages/Revalorizacion';
import Conozcanos from './pages/Conozcanos';
import DescargarFormatos from './pages/DescargarFormatos';
import Comunicados from './pages/Comunicados';
import EventosConcursos from './pages/EventosConcursos';
import Coopsejos from './pages/Coopsejos';
import InfantilJuvenil from './pages/InfantilJuvenil';
import Login from './Administrador/Pages/Login';
import PrincipalAdmin from './Administrador/Pages/Principal';
import LoginFundacion from './Administrador/PagesFundacion/LoginFundacion'
import PrincipalFunda from './Administrador/PagesFundacion/PrincipalFundacion';
import LoginTalentoHumano from './Administrador/PagesTalentoHumano/LoginTalentoHumano';
import PrincipalTalentoH from './Administrador/PagesTalentoHumano/PrincipalTalentoH';

import Error404 from './pages/Error404';
import CanalesAtencion from './pages/CanalesAtencion';
import Servicios from './pages/Servicios';
import Beneficios from './pages/Beneficios';
import TrabajeConNosotros from './pages/TrabajeConNosotros';
import Detalles from './components/Coopsejos/Seccion2/Detalles/Detalles';
import Productos from './pages/Productos';
import FormSolicMultiportal from './components/Formularios/FormSolicMultiportal';
//import Reuniones_Cooperativas from './pages/Reuniones_Cooperativas';
//RQTO. FORM SOLICITUD CÓDIGO QR - MAMV 2026
import FormSolicQrComercio from './components/Formularios/FormSolicQrComercio';

import Documentos from './pages/Documentos';
import ActualizacionWebDian from './pages/ActualizacionWebDian';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LottieLoader from './components/EstrategiasComerciales/CooperaGanaMas/LottieLoader';

/* RQTO. LANDINGPAGE COOPERA Y GANA MAS - 2026 - AMPG */
import CooperaGanaMas from './pages/CooperaGanaMas';
/* RQTO. PLAN ESTIM. COOPENAUTAS - 2026 - DARP */
import Coopenautas from './pages/Coopenautas';

//2023/12/20
import AvisoPrivacidad from './pages/AvisoPrivacidad';
//import EleccionesDelegados from './pages/EleccionesDelegados';

function App() {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({
            duration: 800,
            once: false,
            startEvent: 'DOMContentLoaded'
        });
    }, []);

    return (
        <Router>
            <Switch>
                <Route exact path="/" component={Principal} initial={true} />
                <Route exact path="/Productos/:name/:id/:idtp" component={Productos} />
                <Route exact path="/Productos/:id/:name" component={ProductoDimanicoDigital} initial={true} />
                <Route exact path="/ProductoDimanicoDigital" component={ProductoDimanicoDigital} />

                <Route exact path="/Asesoria" component={Solicitud}  initial={true}/>
                <Route exact path="/Preguntas_Frecuentes" component={Preguntas_Frecuentes} />
                <Route exact path="/Red_Agencias" component={Red_Agencias} />
                <Route exact path="/Simulador/:name" component={Simula} />
                <Route exact path="/Seguros" component={Seguros} />
                <Route exact path="/Convenios/:name" component={Convenios} />
                <Route exact path="/Credito_Libranza" component={CreditoLibranza} />
                <Route exact path="/Quiero_Asociarme" component={QuieroAsociarme} />
                <Route exact path="/Asociados" component={Asociados} />
                <Route exact path="/CDAT" component={CDAT} />
                <Route exact path="/Cooperativa_Virtual" component={SeccionTransaccional} />
                <Route exact path="/PSE" render={() => (<LottieLoader><PSE /></LottieLoader>)}></Route>
                <Route exact path="/Revalorizacion" component={Revalorizacion} />
                <Route exact path="/Conozcanos" component={Conozcanos} />
                <Route exact path="/Descargar_Formatos" component={DescargarFormatos} />
                <Route exact path="/Comunicados" component={Comunicados} />
                <Route exact path="/Eventos_Concursos" component={EventosConcursos} />
                <Route exact path="/Coopsejos" component={Coopsejos} />
                <Route exact path="/Infantil_Juvenil" component={InfantilJuvenil} />
                <Route exact path="/Canales_Atencion" component={CanalesAtencion} />
                <Route exact path="/Servicios" component={Servicios} />
                <Route exact path="/Beneficios" component={Beneficios} />
                <Route exact path="/Trabaje_con_nosotros" component={TrabajeConNosotros} />
                
                <Route exact path="/Noticias/Detalles/:id/:id2" component={Detalles} />
                <Route exact path="/Solicitud_Multiportal" component={FormSolicMultiportal} />
                {/*RQTO. FORM SOLICITUD CÓDIGO QR - MAMV 2026*/}
                <Route exact path="/SolicitudQRComercio" component={FormSolicQrComercio} />

                <Route path="/Documentos/:ruta1/:ruta2" component={Documentos}></Route>
                <Route exact path="/Documentos/:ruta1" component={Documentos}></Route>
                {/*<Route exact path="/Reuniones_Coop" component={Reuniones_Cooperativas}></Route>*/}
                <Route exact path="/ActualizacionWebDian" component={ActualizacionWebDian}></Route>

                {/* RQTO. LANDINGPAGE COOPERA Y GANA MAS - 2026 - AMPG */}
                <Route exact path="/CooperaGanaMas" render={() => (<LottieLoader><CooperaGanaMas /></LottieLoader>)}></Route>
                {/* RQTO. PLAN ESTIM. COOPENAUTAS - 2026 - DARP */}
                <Route exact path="/Coopenautas" render={() => (<LottieLoader><Coopenautas /></LottieLoader>)}></Route>

                {/* Rutas para el Administrador */}
                <Route exact path="/admin/login/utra" component={Login} />
                <Route exact path="/admin/principal" component={PrincipalAdmin} />

                {/* Rutas para el administrador de la fundacion*/}
                <Route exact path="/fundacion/login" component={LoginFundacion} />
                <Route exact path="/fundacion/principal" component={PrincipalFunda} />

                { /* RQTO. HOJA DE VIDA - JPG NOV 2025 */ }
                <Route exact path="/admin/talentoHumano" component={LoginTalentoHumano} />
                <Route exact path="/admin/talentoHumano/principal" component={PrincipalTalentoH} />

                {/* Ruta para aviso de privacidad */}
                <Route exact path="/AvisoPrivacidad" component={AvisoPrivacidad} />

                {/*Ruta para las elecciones de delegados*/}
                {/*<Route exact path="/EleccionesDelegados" component={EleccionesDelegados} />*/}

                <Route component={Error404} />
            </Switch>
        </Router>
    );
}

export default App;